/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CodeQualityPenalties } from './CodeQualityPenalties';
const CodeQualityBaseDataParser = /* #__PURE__ */ parsers.object([
    [
        'wrapper',
        /* #__PURE__ */ parsers.exactly('cg_checkstyle', 'cg_clang_tidy', 'cg_eslint', 'cg_flake8', 'cg_pmd', 'cg_pylint', 'cg_resharper', 'custom'),
    ],
    ['program', codecString],
    ['config', codecString],
    ['args', codecString],
    ['penalties', CodeQualityPenalties],
]);
export class CodeQualityBaseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodeQualityBaseDataParser.decode(input).map(res => new CodeQualityBaseData(res));
    }
    static unsafeDecode(input) {
        return CodeQualityBaseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityBaseDataParser.encode(data);
    }
    static schema() {
        return CodeQualityBaseDataParser.schema();
    }
}
